export enum TransactionType {
    Initial = 0,
    Credit = 1,
    Debit = 2,
    Refund = 3,
    Expiration = 4
}